<template>
  <div id="app">
    <div class="sec-search">
      <div class="w-sl">
        <button v-on:click="modalShow" class="itemsearch-banner is-bdc-pink300" id="search-category">
          <div class="row gg-xsq gg-smq gg-mdh gg-lg2 gg-xl2">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div class="simplesearch ico-search is-bgc-pink300">簡単検索</div>
              <div class="itemname">スチールラック</div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <p>ご希望の条件をチェックするだけでカンタンに価格検索ができ、そのままご注文も可能です。<br>また、現地にて商品確認後の購入も行えますので、あらかじめご相談ください。</p>
            </div>
          </div>
          <div class="mt-sm"><div class="assoonassearch is-bgc-pink400a fix-long-arrow-right">今すぐ使ってみる</div></div>
        </button>
      </div>
    </div>

    <modal name="steel-rack-modal" class="search-modal-wrapper">
      <div class="search-modal-scroll">
        <div class="search-modal-body">
          <div class="modal-close-wrapper">
            <div class="modal-close is-bgc-red100"><button v-on:click="modalHide" class="close-btn"><i class="fa fa-times"></i></button></div>
          </div>

          <div class="search-modal-body-inner search-modal-criteria">
            <a href="#search-criteria" data-toggle="collapse" class="axbtn ax-flat" aria-expanded="true" id="criteria">スチールラック<br class="d-inline d-sm-none d-print-none">検索条件</a>
          </div>
          <div class="collapse show" id="search-criteria">
            <div class="search-modal-body-inner">
                <div class="search-criteria-wrapper" id="formAll">
                  <BottleLess
                  v-model="formData.BottleLess"
                  :name="names.BottleLess"
                  :options="Bottles"
                  @BottleFlag="updateBottleFlag"
                  @WithstandChange="updateWithstandLoad"
                  @HeightChange="updateHeightList"
                  @widthChange="updateWidthList"
                  @depthChange="updateDepthList"
                  />
                  <FormatList
                  v-model="formData.FormatList"
                  :name="names.FormatList"
                  :options="FormatLists"
                  @FormatCalc="updateFormatCalc"
                  />
                  <WithstandLoad
                  v-model="formData.WithstandLoad"
                  :name="names.WithstandLoad"
                  :options="WithstandLoads"
                  :flags="WithstandLoadFlag"
                  @WithstandPrice="updateWithstandPrice"
                  @WithstandFlag="updateWithstandFlag"
                  @widthChange="updateWidthList"
                  />
                  <HeightList
                  v-model="formData.HeightList"
                  :name="names.HeightList"
                  :options="HeightLists"
                  :flag="HeightListFlag"
                  />
                  <WidthList
                  v-model="formData.WidthList"
                  :name="names.WidthList"
                  :options="WidthLists"
                  :flag="WidthListFlag"
                  @WidthPrice="updateWidthPrice"
                  @WidthSecondPrice="secondPrice"
                  @WidthThirdPrice="thirdPrice"
                  @WidthFlag="updateWidthFlag"
                  />
                  <DepthList
                  v-model="formData.DepthList"
                  :name="names.DepthList"
                  :options="DepthLists"
                  :flag="DepthListFlag"
                  @DepthFlag="updateDepthFlag"
                  />
                  <BoardList
                  v-model="formData.BoardList"
                  :name="names.BoardList"
                  :options="BoardLists"
                  @BoardCalc="updateBoardCalc"
                  />
                  
                </div>
                <hr class="hr-sm">

                <div v-if="errors.length" id="errors" style="border: 2px solid rgba(219,87,87,1); padding: 10px; font-size: 1.6em; margin: 10px; color: rgb(183, 0, 0); font-weight: bold; display: block;">{{ errors }}</div>

                <div class="row gg-xs1 gg-sm1 gg-md2 gg-lg2 gg-xl2 aic">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <dl class="number"><dt>台数</dt>
                    <dd>
                    <select name="amount" v-model="formData.amount">
                      <option v-for="n in 99" :key="n" :value="n">{{ n }}台</option>
                    </select>
                    </dd>
                    </dl>
                  </div>

                  <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <button @click="reset()" type="button" class="axbtn ax-flat ax-rd ico-reset" id="search-button">リセット</button>
                  </div>
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <button @click="checkFrom" type="button" class="axbtn ax-flat ax-rd ico-search" id="search-button">この内容で価格を調べる</button>
                  </div>
                </div>
                <div class="row gg-xs1 gg-sm1 gg-md2 gg-lg2 gg-xl2 aic">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="color:red; font-size:14px; padding-top:10px;">※受注生産・カスタムサイズでのご注文は“市場価格”となり、お見積りを作成しお送りいたします。</div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="font-size:14px; padding-top:10px;">※スチールラックの部品・パーツ、その他カスタムサイズでのご注文は <a href="/mitsumori.html" class="link-color" target="_blank">&raquo;こちらから</a></div>
                </div>
            </div>
          </div>
          <div class="search-modal-body-inner" v-if="cartItems.length">
            <form action="/product/estimate" method="post" name="estimate">
              <h1 class="tit-lv1"><small class="is-txt-pink500">Search results</small>検索結果</h1>
                <div class="table-responsive">
                  <table class="search-item-wrapper">
                    <tr class="search-item-header">
                      <th class="search-item-name">検索内容</th>
                      <th class="search-item-name">価格</th>
                      <th class="search-item-number">数量</th>
                      <th class="search-item-price">耐荷重</th>
                      <th class="search-item-subtotal">小計</th>
                      <th class="search-item-delete">削除</th>
                    </tr>
                    
                    <tr class="search-item" v-for="(item, index) in cartItems" :key="index">
                      <template v-if="item.marketprice">
                        <input type="hidden" :name="'data[' + index + '][id]'" :value="index" />
                        <input type="hidden" :name="'data[' + index + '][price]'" :value="item.total" />
                        <input type="hidden" :name="'data[' + index + '][word30]'" :value="item.word30" />
                        <input type="hidden" :name="'data[' + index + '][word1]'" :value="item.word1" />
                        <input type="hidden" :name="'data[' + index + '][word2]'" :value="item.word2" />
                        <input type="hidden" :name="'data[' + index + '][word3]'" :value="item.word3" />
                        <input type="hidden" :name="'data[' + index + '][word4]'" :value="item.word4" />
                        <input type="hidden" :name="'data[' + index + '][word5]'" :value="item.word5" />
                        <input type="hidden" :name="'data[' + index + '][word6]'" :value="item.word6" />
                        <input type="hidden" :name="'data[' + index + '][amount]'" :value="item.amount" />
                        <input type="hidden" :name="'data[' + index + '][flag]'" :value="item.marketprice" />
                        <td class="search-item-name">
                          {{ item.word30 }}<template v-if="item.word6 === '支柱1本(増結) 連結タイプ'"> 連結タイプ</template><template v-else> 単体タイプ</template><br>
                          {{ `高さ${item.word2} × 横幅${item.word3} × 奥行${item.word4}` }}<br>{{ `棚板数${item.word5}` }}
                        </td>
                        <td class="search-item-number" style="color:red;">※市場価格</td>
                        <td class="search-item-number">{{ item.amount }}台</td>
                        <td class="search-item-price">{{ item.word1 }}</td>
                        <td class="search-item-subtotal" style="color:red;">※市場価格</td>
                        <td class="search-item-delete"><button type="button" class="axbtn ax-flat ax-xs" v-on:click="deleteItem(index)">削除</button></td>
                      </template>
                      <template v-else>
                        <input type="hidden" :name="'data[' + index + '][id]'" :value="index" />
                        <input type="hidden" :name="'data[' + index + '][price]'" :value="item.total" />
                        <input type="hidden" :name="'data[' + index + '][word30]'" :value="item.word30" />
                        <input type="hidden" :name="'data[' + index + '][word1]'" :value="item.word1" />
                        <input type="hidden" :name="'data[' + index + '][word2]'" :value="item.word2" />
                        <input type="hidden" :name="'data[' + index + '][word3]'" :value="item.word3" />
                        <input type="hidden" :name="'data[' + index + '][word4]'" :value="item.word4" />
                        <input type="hidden" :name="'data[' + index + '][word5]'" :value="item.word5" />
                        <input type="hidden" :name="'data[' + index + '][word6]'" :value="item.word6" />
                        <input type="hidden" :name="'data[' + index + '][amount]'" :value="item.amount" />
                        <input type="hidden" :name="'data[' + index + '][flag]'" :value="item.marketprice" />
                        <td class="search-item-name">
                          {{ item.word30 }}<template v-if="item.word6 === '支柱1本(増結) 連結タイプ'"> 連結タイプ</template><template v-else> 単体タイプ</template><br>
                          {{ `高さ${item.word2} × 横幅${item.word3} × 奥行${item.word4}` }}<br>{{ `棚板数${item.word5}` }}
                        </td>
                        <td class="search-item-number">{{ (item.total / item.amount).toLocaleString() }} 円 (税抜)</td>
                        <td class="search-item-number">
                        <!-- <select name="`item-${ index }-amount`" id="`item-${ index }-amount`" v-model="selected0">
                          <template v-for="n in 99">
                          <option v-bind:key="n" v-bind:value="n" v-if="item.amount == n" selected>{{ item.amount }}台</option>
                          <option v-bind:key="n" v-bind:value="n" v-else>{{ n }}台</option>
                          </template>
                        </select> -->
                        {{ item.amount }}台</td>
                        <td class="search-item-price">{{ item.word1 }}</td>
                        <td class="search-item-subtotal">{{ item.total.toLocaleString() }} 円 (税抜)</td>
                        <td class="search-item-delete"><button type="button" class="axbtn ax-flat ax-xs" v-on:click="deleteItem(index)">削除</button></td>
                      </template>
                    </tr>
                  </table>
                </div>
                <table class="search-item-total mt-sm">
                  <tr class="search-item-header">
                    <th class="search-item-number">合計数量({{ cartItems.length }}件)</th>
                    <th class="search-item-subtotal">小計合計金額</th>
                  </tr>
                  <tr class="search-item">
                    <td class="search-item-number">{{ totalQty }} 台</td>
                    <td class="search-item-price">{{ totalPrice.toLocaleString() }}<template v-if="totalPrice != '市場価格'">円 (税抜)</template></td>
                  </tr>
                </table>

                <div class="mt-md">
                  <div class="row gg-xs1 gg-sm1 gg-md2 gg-lg2 gg-xl2 jcc">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <a href="#search-criteria" @click="searchShow" class="axbtn ax-solid ax-rd ax-lg arrow-right">検索条件へ</a>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <button @click="addEstimate" type="button" class="axbtn ax-solid ax-rd ax-lg arrow-right">お見積りリストへ</button>
                    </div>
                  </div>
                </div>
              </form>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
function initialState() {
  return {
      formData: {
        BottleLess:'',
        WithstandLoad:'',
        HeightList: '',
        WidthList: '',
        DepthList: '',
        BoardList: '',
        FormatList: '',
        amount:1,
      },

      calcs: {
        FormatList:1,
        WithstandLoad:0,
        WidthList:0,
        BoardList:1,
      },

      marketPrice: {
        BottleLess:false,
        WithstandLoad:false,
        HeightList:false,
        WidthList:false,
        DepthList:false,
      },

      names: {
        BottleLess:'word30',
        WithstandLoad:'word1',
        HeightList: 'word2',
        WidthList: 'word3',
        DepthList: 'word4',
        BoardList: 'word5',
        FormatList: 'word6',
       },


      cartItems: [],

      totalQty: 0,
      // totalWeight: 0,
      totalPrice: 0,

      errors: '',
      
      cartUrl:'/product/ajaxPostCart',

      mitsumori: '/mitsumori.html',

      WithstandLoadFlag: {
        'A':true,
        'B':true,
        'C':true,
        'D':true,
        'E':true,
      },
      HeightListFlag: {
        'A':true,
        'B':true,
        'C':true,
      },
      WidthListFlag: {
        'A':true,
        'B':true,
        'C':true,
        'D':true,
        'E':true,
      },
      DepthListFlag: {
        'A':true,
        'B':true,
        'C':true,
      },
      

      Bottles: [
        {
        id:'A',
        value:'<small>即納可能</small>スチールラック',
        data:'即納可能 スチールラック',
        flag:false,
        },
        {
        id:'B',
        value:'<small>受注生産</small>スチールラック',
        data:'受注生産 スチールラック',
        flag:true,
        },
      ],
      FormatLists: [
        {
        id:'A',
        value:'<small>支柱2本(基本)</small>単体タイプ',
        data:'支柱2本(基本) 単体タイプ',
        calc:2,
        },
        {
        id:'B',
        value:'<small>支柱1本(増結)</small>連結タイプ',
        data:'支柱1本(増結) 連結タイプ',
        calc:1,
        },
      ],
      WithstandLoads: [
        {
        id:'A',
        value:"100kg / 段",
        data:"100kg",
        price:1400,
        flag:false,
        },
        {
        id:'B',
        value:"200kg / 段",
        data:"200kg",
        price:2200,
        flag:false,
        },
        {
        id:'C',
        value:"300kg / 段",
        data:"300kg",
        price:3300,
        flag:false,
        },
        {
        id:'D',
        value:"400kg / 段",
        data:"400kg",
        price:0,
        flag:true,
        },
        {
        id:'E',
        value:"500kg / 段",
        data:"500kg",
        price:0,
        flag:true,
        },
      ],
      HeightLists: [
        {
        id:'A',
        value:'1500mm',
        data:'1500mm',
        },
        {
        id:'B',
        value:'1800mm',
        data:'1800mm',
        },
        {
        id:'C',
        value:'2000mm',
        data:'2000mm',
        },
      ],
      WidthLists: [
        {
        id:'A',
        value:'1000mm',
        data:'1000mm',
        price:1500,
        flag:false,
        },
        {
        id:'B',
        value:'1200mm',
        data:'1200mm',
        price:1800,
        flag:false,
        },
        {
        id:'C',
        value:'1500mm',
        data:'1500mm',
        price:2000,
        secondprice:2700,
        flag:false,
        },
        {
        id:'D',
        value:'1800mm',
        data:'1800mm',
        price:0,
        flag:true,
        },
        {
        id:'E',
        value:'2000mm',
        data:'2000mm',
        price:2500,
        secondprice:3700,
        thirdprice:5300,
        flag:false,
        },
      ],
      DepthLists: [
        {
        id:'A',
        value:'400mm',
        data:'400mm',
        flag:true,
        },
        {
        id:'B',
        value:'500mm',
        data:'500mm',
        flag:false,
        },
        {
        id:'C',
        value:'600mm',
        data:'600mm',
        flag:true,
        },
      ],
      BoardLists: [
        {
        id:'A',
        value:'3段',
        data:'3段',
        calc:3,
        },
        {
        id:'B',
        value:'4段',
        data:'4段',
        calc:4,
        },
        {
        id:'C',
        value:'5段',
        data:'5段',
        calc:5,
        },
        {
        id:'D',
        value:'6段',
        data:'6段',
        calc:6,
        },
        {
        id:'E',
        value:'7段',
        data:'7段',
        calc:7,
        },
        {
        id:'F',
        value:'8段',
        data:'8段',
        calc:8,
        },
        {
        id:'G',
        value:'9段',
        data:'9段',
        calc:9,
        },
        {
        id:'H',
        value:'10段',
        data:'10段',
        calc:10,
        },
      ],
    }
}

import WithstandLoad from './components/WithstandLoad.vue'
import HeightList from './components/HeightList.vue'
import WidthList from './components/WidthList.vue'
import DepthList from './components/DepthList.vue'
import BoardList from './components/BoardList.vue'
import FormatList from './components/FormatList.vue'
import BottleLess from './components/BottleLess.vue'


export default {
  name: 'App',
  components: {
    WithstandLoad,
    HeightList,
    WidthList,
    DepthList,
    BoardList,
    FormatList,
    BottleLess,
  },
  data() {
    return initialState()
  },
  methods: {
    // カスタムバリデーション
    checkFrom: function() {
      if (this.formData.WithstandLoad &&
          this.formData.HeightList &&
          this.formData.WidthList &&
          this.formData.DepthList &&
          this.formData.BoardList &&
          this.formData.FormatList &&
          this.formData.BottleLess) {
            this.errors = '';
            this.addCart();
            return true;
      }
      if (!this.formData.BoardList){
        this.errors ='段数を選択してください';
      }
      if (!this.formData.DepthList){
        this.errors = '奥行きを選択してください';
      }
      if (!this.formData.WidthList){
        this.errors = '横幅を選択してください';
      }
      if (!this.formData.HeightList){
        this.errors = '高さを選択してください';
      }
      if (!this.formData.WithstandLoad){
        this.errors = '耐荷重を選択してください';
      }
      if (!this.formData.FormatList){
        this.errors ='形式を選択してください';
      }
      if (!this.formData.BottleLess){
        this.errors ='ボトルレスを選択してください';
      }
      // e.preventDefault();
    },
    addCart: function() {
      let postData = {
        word1: this.formData.WithstandLoad,
        word2: this.formData.HeightList,
        word3: this.formData.WidthList,
        word4: this.formData.DepthList,
        word5: this.formData.BoardList,
        word6: this.formData.FormatList,
        word30: this.formData.BottleLess,
        amount: this.formData.amount,
        marketprice: false,
        total:0,
      }

      let subtotal = (this.calcs.FormatList * this.calcs.WithstandLoad) + (this.calcs.WidthList * this.calcs.BoardList);
      let total = this.formData.amount * subtotal;

      postData.total = total;

      let wk = this.marketPrice;
      
      for (let flag in wk) {
        if(wk[flag] === true){
          postData.marketprice = true;
        }
      }

      if(postData){
      this.cartItems.push(postData)
      var target = document.getElementById('search-criteria');
      target.classList.remove('show');
      }
      // 基本データが見つからないことがなくなったので、一旦コメントアウト。
      //  else {
      //   this.errors = "データが見つかりませんでした。";
      // }
    },

    addEstimate: function() {
      document.estimate.submit();
    },

    searchShow : function() {
      var target = document.getElementById('search-criteria');
      if(!target.classList.contains('show')){
        target.classList.add('show');
      }
    },

    modalShow : function() {
      this.$modal.show('steel-rack-modal');
    },
    modalHide : function () {
      this.$modal.hide('steel-rack-modal');
      this.reset();
    },

    // 1. 引数なし モーダルウィンドウの☓ボタン押した時すべてのdataを初期化。
    // 2. 引数あり ラジオを選択した時、選択した箇所より後ろのデータをリセット。(再選択防止)
    reset : function(num = 0, length = 0) {
      var form = document.querySelectorAll("input");
      if(num == 0){
        Object.assign(this.$data, this.$options.data.call(this));
        form.forEach(val => {
          val.checked = false;
        });
      } else {
          form.forEach((val,key) => {
            if(key >= length){
              val.checked = false;
            }
          });
        if(num == 1){
          this.formData.FormatList = '';
          this.formData.WithstandLoad = '';
          this.formData.HeightList = '';
          this.formData.WidthList = '';
          this.formData.DepthList = '';
          this.formData.BoardList = '';
        }
        if(num == 2){
          this.formData.WithstandLoad = '';
          this.formData.HeightList = '';
          this.formData.WidthList = '';
          this.formData.DepthList = '';
          this.formData.BoardList = '';
        }
        if(num == 3){
          this.formData.HeightList = '';
          this.formData.WidthList = '';
          this.formData.DepthList = '';
          this.formData.BoardList = '';
        }
        if(num == 4){
          this.formData.WidthList = '';
          this.formData.DepthList = '';
          this.formData.BoardList = '';
        }
        if(num == 5){
          this.formData.DepthList = '';
          this.formData.BoardList = '';
        }
        if(num == 6){
          this.formData.BoardList = '';
        }
      }
    },

    // ボトルレスを選択したときすべてのフラグ(選択可否)を書き換える
    updateWithstandLoad(arr) {
      this.WithstandLoadFlag = arr
    },
    updateHeightList(arr) {
      this.HeightListFlag = arr
    },
    updateWidthList(arr) {
      this.WidthListFlag = arr
    },
    updateDepthList(arr) {
      this.DepthListFlag = arr
    },

    // 子コンポーネントから受け取った計算のパーツ(金額など)をdataに上書き
    updateFormatCalc(multi) {
      this.calcs.FormatList = multi
    },
    updateWithstandPrice(price) {
      this.calcs.WithstandLoad = price
    },
    updateWidthPrice(price) {
      this.calcs.WidthList = price
    },
    secondPrice(second) {
      if(second != 0 && this.formData.WithstandLoad == "200kg"){
        this.calcs.WidthList = second
      }
    },
    thirdPrice(third) {
      if(third != 0 && this.formData.WithstandLoad == "300kg"){
        this.calcs.WidthList = third
      }
    },
    updateBoardCalc(multi) {
      this.calcs.BoardList = multi
    },

    // 子コンポーネントから受け取った市場価格かどうかのフラグをdataに上書き
    updateBottleFlag(value) {
      this.marketPrice.BottleLess = value
    },
    updateWithstandFlag(value) {
      this.marketPrice.WithstandLoad = value
    },
    // updateHeightFlag(value) {
    //   this.marketPrice.HeightList = value;
    // },
    updateWidthFlag(value) {
      this.marketPrice.WidthList = value
    },
    updateDepthFlag(value) {
      this.marketPrice.DepthList = value
    },

    deleteItem(index) {
      this.cartItems.splice(index, 1);
    }
  },
  watch: {
    'formData.amount'(value) {
      this.formData.amount = value
    },
    'formData.BottleLess'() {
      this.reset(1, Object.keys(this.Bottles).length);
    },
    'formData.FormatList'() {
      const total = Object.keys(this.FormatLists).length + Object.keys(this.Bottles).length;
      this.reset(2, total);
    },

    'formData.WithstandLoad'(value) {
      // 即納可能かつ、耐荷重が変更された時
      let widthList = {"A":true,"B":true,"C":true,"D":true,"E":true};
      let heightList = {"A":true,"B":true,"C":true};
      if(value === "100kg" && this.formData.BottleLess === "即納可能 スチールラック"){
        widthList = {"A":true,"B":true,"C":true,"D":false,"E":true};
        heightList = {"A":true,"B":true,"C":true};
      }
      if(value === "200kg" && this.formData.BottleLess === "即納可能 スチールラック"){
        widthList = {"A":false,"B":false,"C":true,"D":false,"E":true};
        heightList = {"A":false,"B":false,"C":true};
      }
      if(value === "300kg" && this.formData.BottleLess === "即納可能 スチールラック"){
        widthList = {"A":false,"B":false,"C":false,"D":false,"E":true};
        heightList = {"A":false,"B":false,"C":true};
      }
      this.WidthListFlag = widthList;
      this.HeightListFlag = heightList;
      const total = Object.keys(this.WithstandLoads).length + Object.keys(this.FormatLists).length + Object.keys(this.Bottles).length;
      this.reset(3, total);
    },

    'formData.HeightList'(value) {
      if (this.formData.BottleLess === "即納可能 スチールラック") {
        this.marketPrice.HeightList = false;
      } else if (value == "1500mm") {
        this.marketPrice.HeightList = true;
      } else if (value == "1800mm") {
        this.marketPrice.HeightList = true;
      } else {
        this.marketPrice.HeightList = false;
      }

      const total = Object.keys(this.HeightLists).length + Object.keys(this.WithstandLoads).length + Object.keys(this.FormatLists).length + Object.keys(this.Bottles).length;
      this.reset(4, total);
    },
    'formData.WidthList'(value) {
      if(this.formData.BottleLess == "受注生産 スチールラック"){
        var depthList = {"A":true,"B":true,"C":true};
        // 耐荷重100kgのとき
        if(value == "1000mm" && this.formData.HeightList == "2000mm" && this.formData.WithstandLoad == "100kg") {
        depthList = {"A":true,"B":false,"C":true};
        }
        if(value == "1200mm" && this.formData.HeightList == "2000mm" && this.formData.WithstandLoad == "100kg") {
        depthList = {"A":true,"B":false,"C":true};
        }
        if(value == "1500mm" && this.formData.HeightList == "2000mm" && this.formData.WithstandLoad == "100kg") {
        depthList = {"A":true,"B":false,"C":true};
        }
        if(value == "2000mm" && this.formData.HeightList == "2000mm" && this.formData.WithstandLoad == "100kg") {
        depthList = {"A":true,"B":false,"C":true};
        }
        // 耐荷重200kgのとき
        if(value == "1500mm" && this.formData.HeightList == "2000mm" && this.formData.WithstandLoad == "200kg") {
        depthList = {"A":true,"B":false,"C":true};
        }
        if(value == "2000mm" && this.formData.HeightList == "2000mm" && this.formData.WithstandLoad == "200kg") {
        depthList = {"A":true,"B":false,"C":true};
        }
        // 耐荷重300kgのとき
        if(value == "2000mm" && this.formData.HeightList == "2000mm" && this.formData.WithstandLoad == "300kg") {
        depthList = {"A":true,"B":false,"C":true};
        }

        this.DepthListFlag = depthList;
      }
      
      const total = Object.keys(this.WidthLists).length + Object.keys(this.HeightLists).length + Object.keys(this.WithstandLoads).length + Object.keys(this.FormatLists).length + Object.keys(this.Bottles).length;
      this.reset(5, total);
    },
    'formData.DepthList'() {
      const total = Object.keys(this.DepthLists).length + Object.keys(this.WidthLists).length + Object.keys(this.HeightLists).length + Object.keys(this.WithstandLoads).length + Object.keys(this.FormatLists).length + Object.keys(this.Bottles).length;
      this.reset(6, total);
    },

    'cartItems'() {

      this.totalQty = this.cartItems.reduce(
        (sum, i) => sum + (i.amount || 0),0);

      // this.totalWeight = this.cartItems.reduce(
      //   (sum, i) => sum + (i.decimal1 * i.amount || 0),0);

      this.totalPrice = this.cartItems.reduce((sum, i) =>
        i.marketprice === false ? (sum + i.total) : sum
      ,0);

      for(const flag in this.cartItems) {
        if(this.cartItems[flag].marketprice === true){
          this.totalPrice = "市場価格"
        }
      }
    },
  }

}
</script>